exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.equip-accordion[data-v-746f1c7c] {\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n  overflow: hidden;\n}\n", ""]);

// exports
